$(document).ready(function () {
    $("#subscribe-form").on('submit', function (e) {
        e.preventDefault()
        $("#div_loading").addClass("loading-almadia")
        let data = new FormData(this)
        $.ajax({
            url: 'subscribe',
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                setTimeout(() => {
                    $("#div_loading").removeClass("loading-almadia")
                    if (response.success) {
                        $("#item-email-suscribe").val('');
                        alertSuccess(response.msj)
                    } else {
                        alertError(response.msj)
                    }
                }, 1000);
            },
            error: function (jqXHR, xhr, status,) {
                $("#div_loading").removeClass("loading-almadia")
                swal.fire({
                    icon: 'error',
                    confirmButtonColor: "#eb0c0c",
                    title: 'Ocurrió un error',
                })
            }
        })
    });

    $("#subscribe-form-es").on('submit', function (e) {
        e.preventDefault();

        const email = $("#email-subscribe-es").val().trim();

        if (email === '' || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            swal.fire({
                icon: 'warning',
                title: 'Correo inválido',
                text: 'Por favor ingresa un correo válido.'
            });
            return;
        }

        $("#div_loading").addClass("loading-almadia");
        let data = new FormData();
        data.append('email', email);
        data.append('name', '');

        $.ajax({
            url: 'subscribe',
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                setTimeout(() => {
                    $("#div_loading").removeClass("loading-almadia");
                    if (response.success) {
                        $("#email-subscribe-es").val('');
                        alertSuccess(response.msj);
                        setTimeout(() => {
                            $('#subscribe-modal-es').modal('hide');
                        }, 300);
                    } else {
                        alertError(response.msj);
                    }
                }, 1000);
            },
            error: function () {
                $("#div_loading").removeClass("loading-almadia");
                swal.fire({
                    icon: 'error',
                    confirmButtonColor: "#eb0c0c",
                    title: 'Ocurrió un error'
                });
            }
        });
    });

})
